import { AfterViewInit, Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, Host } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone:true,
  templateUrl: './home.component.html',
  imports:[RouterModule],
  styleUrls: ['./home.component.css'],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponent implements AfterViewInit,OnInit {

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const swiperEl = document.querySelector('swiper-container');
    const prevButtonEl = document.querySelector('.w-slider-arrow-left');
    const nextButtonEl = document.querySelector('.w-slider-arrow-right');
        
    nextButtonEl?.addEventListener('click', () => {
    swiperEl?.swiper.slideNext();
    });

    prevButtonEl?.addEventListener('click', () => {
      swiperEl?.swiper.slidePrev();
    });
  }
}